import moment from "moment";
import _ from "lodash";

export const getTimezoneOption = async () => {
  let timeZones = [];
  timeZones = moment.tz.names();
  var offsetTmz = [];
  if (timeZones) {
    for (var i in timeZones) {
      let each_timezone = {};
      each_timezone = {
        value: timeZones[i],
        label:
          timeZones[i] + //split here based on $ to get timezone
          `-${moment.tz(timeZones[i]).format("z")} (GMT ${moment
            .tz(timeZones[i])
            .format("Z")})`,
        id:
          timeZones[i] +
          `-${moment.tz(timeZones[i]).format("z")} (GMT ${moment
            .tz(timeZones[i])
            .format("Z")})`,
        name:
          timeZones[i] +
          `-${moment.tz(timeZones[i]).format("z")} (GMT ${moment
            .tz(timeZones[i])
            .format("Z")})`,
        text:
          `(GMT ${moment.tz(timeZones[i]).format("Z")}) ` +
          timeZones[i] +
          `-${moment.tz(timeZones[i]).format("z")} `,
        time: moment.tz(timeZones[i]).format("Z"), /// added for filtering only
        timeslip: +moment.tz(timeZones[i]).format("Z").split(":")[0], /// added for filtering only

        gmt: `${timeZones[i]} (UTC ${moment.tz(timeZones[i]).format("Z")})`,
      };
      offsetTmz.push(each_timezone);
    }
  }
  let sortedData = await getsortedData(offsetTmz);
  return await sortedData;
};

const getsortedData = async (data) => {
  const posArr = data.filter((num) => num["timeslip"] > -1);
  const positivesort = _.orderBy(posArr, ["time"], ["asc"]);
  const negArr = data.filter((num) => num["timeslip"] < -1);
  const negativesort = _.orderBy(negArr, ["time"], ["desc"]);
  return [...negativesort, ...positivesort];
};
